'use client';

import { useTranslations, useLocale } from 'next-intl';

/**
 * Compact documents access card for the public verification UI.
 * Shows links to Instructions for Use and compliance documents
 * in the pub-card theme style.
 */
export function DocumentsCard() {
  const t = useTranslations('public');
  const locale = useLocale();

  return (
    <div className="pub-card" style={{ padding: '14px 16px' }}>
      <div className="flex items-center gap-3 mb-3">
        <div
          className="flex items-center justify-center flex-shrink-0"
          style={{
            width: 38,
            height: 38,
            borderRadius: 10,
            background: 'var(--pub-surface-3)',
            border: '1px solid var(--pub-border)',
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="var(--pub-text-secondary)" strokeWidth="2" width="18" height="18">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <polyline points="10 9 9 9 8 9" />
          </svg>
        </div>
        <div className="min-w-0">
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--pub-text-primary)' }}>
            {t('documents.title')}
          </div>
          <div style={{ fontSize: 11, color: 'var(--pub-text-muted)', marginTop: 1 }}>
            {t('documents.subtitle')}
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-1.5">
        {/* Instructions for Use */}
        <a
          href={`/${locale}/instructions`}
          className="flex items-center gap-2.5 transition-colors duration-150"
          style={{
            padding: '9px 12px',
            borderRadius: 10,
            background: 'var(--pub-surface-3)',
            border: '1px solid var(--pub-border)',
            textDecoration: 'none',
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="var(--pub-blue)" strokeWidth="2" width="16" height="16">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
          </svg>
          <span style={{ fontSize: 12, color: 'var(--pub-text-primary)', fontWeight: 500 }}>
            {t('documents.instructions')}
          </span>
          <svg
            viewBox="0 0 24 24" fill="none" stroke="var(--pub-text-muted)" strokeWidth="2"
            width="12" height="12" className="ml-auto flex-shrink-0"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </a>

        {/* Compliance Documents */}
        <a
          href={`/${locale}/docs`}
          className="flex items-center gap-2.5 transition-colors duration-150"
          style={{
            padding: '9px 12px',
            borderRadius: 10,
            background: 'var(--pub-surface-3)',
            border: '1px solid var(--pub-border)',
            textDecoration: 'none',
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="var(--pub-green)" strokeWidth="2" width="16" height="16">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          <span style={{ fontSize: 12, color: 'var(--pub-text-primary)', fontWeight: 500 }}>
            {t('documents.compliance')}
          </span>
          <svg
            viewBox="0 0 24 24" fill="none" stroke="var(--pub-text-muted)" strokeWidth="2"
            width="12" height="12" className="ml-auto flex-shrink-0"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </a>
      </div>
    </div>
  );
}
